export enum BankAccountStateFilters {
  ALL = 'all',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export default {
  BankAccountStateFilters,
};
